import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import "../../assets/css/stylesPage.css";

import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/CustomButton.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import stylesDialogs from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

const useStyles = makeStyles(styles);

import "react-credit-cards/es/styles-compiled.css";
import "../../assets/css/stylesPage.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStylesDialog = makeStyles(stylesDialogs);

import { useTranslation } from "react-i18next";

export default function CustomModal({ children, ...props }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const classesDialogs = useStylesDialog();
  const { isOpen, onClose, title, privacy, id, terms } = props;

  if (!isOpen) {
    return null;
  }

  const payment = t("payment", { returnObjects: true }); // Obtiene todas las traducciones bajo "payment"

  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal + (terms === true ? " " + classes.modalTerms : "") ,
      }}
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => onClose(false)}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
      id={typeof id !== "undefined" ? id : "modalClassic"}
    >
      <DialogTitle
        id="classic-modal-slide-title"
        disableTypography
        className={classes.modalHeader}
      >
        <h3
          className={
            classesDialogs.modalTitle + " " + classesDialogs.modalTitlePayment
          }
        >
          {title}
        </h3>
        <Button
          justIcon
          className={
            classesDialogs.modalCloseButton +
            " " +
            classesDialogs.buttonPaymentClose
          }
          key="close"
          aria-label="Close"
          onClick={() => onClose(false)}
        >
          <Close className={classesDialogs.modalClose} />
        </Button>
      </DialogTitle>
      <DialogContent className={classes.modalBody + " modalCreditCard"}>
        <GridContainer>{children}</GridContainer>
      </DialogContent>
      {privacy && (
        <DialogActions
          className={classesDialogs.modalFooter}
          style={{
            backgroundColor: "#000",
            color: "#FFF",
            paddingTop: "2em",
            paddingBottom: "2em",
          }}
        >
          <GridItem xs={12} className={classesDialogs.center}>
            <a href="#" className={classesDialogs.linkPayment}>
              {payment.privacyPolicy}
            </a>{" "}
            | {payment.disclaimer}
          </GridItem>
        </DialogActions>
      )}
    </Dialog>
  );
}
